/**
 * One subscribable product on a channel, as the notification API represents it.
 */
export interface NotificationChannelProduct {
  /**
   * The product this subscription covers, for example `PRODUCT_REVIEWS` or
   * `SERVICE_REVIEWS`.
   */
  productName: string;

  /**
   * Whether the receiver is subscribed to this product on this channel.
   */
  enabled: boolean;

  properties: {
    /**
     * The star ratings the receiver is notified about, as values from 1 to 5.
     *
     * An empty array and a full array of all five values both mean the same
     * thing to the API as `enabled: false`. The service reproduces that.
     */
    ratingFilter: number[];
  };
}
